export default {
  loading: {
    id: 'bo_seller-homepage-loading',
    defaultMessage: 'Loading...',
  },
  taskList: {
    id: 'bo_seller-homepage-task_list',
    defaultMessage: 'Task list',
  },
  noTasks: {
    id: 'bo_seller-homepage-task_list-no_tasks',
    defaultMessage: 'You are up to date!',
  },
}
